export const SubModule = ({ value, record }) => record.result?.subModule;
